import { render } from "./HeroiconsOutlineFastForward.vue?vue&type=template&id=68ccaa02"
const script = {}

import exportComponent from "/var/www/doughcoteam.co.uk/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineFastForward.vue"]])

export default __exports__